

function timestampNow(): number {
  return (new Date()).getTime();
}

export default timestampNow;

